import {
  ACTIONS_HISTORY_LABEL,
  ACTIONS_HISTORY_PATH,
  AI_ACTIONS_HISTORY_PATH,
  AI_PROMPTS_SETTINGS_LABEL,
  AI_PROMPTS_SETTINGS_PATH,
  PAID_AI_FEATURES_LABEL,
  PAID_AI_FEATURES_PATH,
  BRANCHES_LABEL,
  BRANCHES_PATH,
  CALENDAR_SETTINGS_LABEL,
  CALENDAR_SETTINGS_PATH,
  CATEGORIES_LABEL,
  CATEGORIES_PATH,
  CHAINS_LABEL,
  CHAINS_PATH,
  CLIENT_SERVICES_LABEL,
  CLIENT_SERVICES_PATH,
  DATA_MIGRATION_LABEL,
  DATA_MIGRATION_PATH,
  EMPLOYEES_LABEL,
  EMPLOYEES_PATH,
  INTEGRATIONS_LABEL,
  INTEGRATIONS_PATH,
  LEGAL_ENTITIES_LABEL,
  LEGAL_ENTITIES_PATH,
  MESSAGE_TEMPLATES,
  MESSAGE_TEMPLATES_LABEL,
  MESSAGE_TEMPLATES_PATH,
  OPERATIONS_LABEL,
  OPERATIONS_PATH,
  PAYMENTS_ACCOUNTS_LABEL,
  PAYMENTS_ACCOUNTS_PATH,
  POSITIONS_LABEL,
  POSITIONS_PATH,
  PROFILE_LABEL,
  PROFILE_PATH,
  SALE_PLANS_LABEL,
  SALE_PLANS_PATH,
  SCHEDULE_PATH,
  TAGS_LABEL,
  TAGS_PATH,
  CLIENT_FIELDS_LABEL,
  CLIENT_FIELDS_PATH,
  SUBSCRIPTIONS_LABEL,
  SUBSCRIPTIONS_PATH,
  CERTIFICATES_LABEL,
  CERTIFICATES_PATH,
  USERS_LABEL,
  USERS_PATH,
  WORK_SCHEDULES_LABEL,
  NOTIFICATIONS_LABEL,
  NOTIFICATIONS_PATH,
  SUPPLIERS_LABEL,
  SUPPLIERS_PATH,
  BRANDS_LABEL,
  BRANDS_PATH,
  PRODUCT_CATEGORIES_LABEL,
  PRODUCT_CATEGORIES_PATH,
  GOODS_UNITS_PATH,
  GOODS_UNITS_LABEL,
  SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_LABEL,
  SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_PATH,
  PURCHASE_PLANNING_SETTINGS_PATH,
  PURCHASE_PLANNING_LABEL,
  DETACH_RESPONSIBLE_FROM_LEAD_LABEL,
  DETACH_RESPONSIBLE_FROM_LEAD_PATH,
  DOCUMENT_TEMPLATES,
  DOCUMENT_TEMPLATES_LABEL,
  DOCUMENT_TEMPLATES_PATH,
  MCP_INTEGRATION_LABEL,
  MCP_INTEGRATION_PATH,
  PROXY_LABEL,
  PROXY_PATH,
} from '@app/constants';
import { NNavigation } from '@app/types/Navigation';

export const menu: NNavigation.Settings = [
  {
    groupName: NNavigation.EGroupNameInSettings.RECORD_SETTINGS,
    groupDataTestId: 'record-settings',
    items: [
      {
        name: CLIENT_SERVICES_LABEL,
        path: CLIENT_SERVICES_PATH,
        dataTestId: 'services',
      },
      {
        name: POSITIONS_LABEL,
        path: POSITIONS_PATH,
        dataTestId: 'positions',
      },
      {
        name: EMPLOYEES_LABEL,
        path: EMPLOYEES_PATH,
        dataTestId: 'performers',
      },
      {
        name: WORK_SCHEDULES_LABEL,
        path: SCHEDULE_PATH,
        dataTestId: 'schedule',
      },
      {
        name: CATEGORIES_LABEL,
        path: CATEGORIES_PATH,
        dataTestId: 'service-categories',
      },
      {
        name: TAGS_LABEL,
        path: TAGS_PATH,
        dataTestId: 'tags',
      },
      {
        name: CALENDAR_SETTINGS_LABEL,
        path: CALENDAR_SETTINGS_PATH,
      },
      {
        name: NOTIFICATIONS_LABEL,
        path: NOTIFICATIONS_PATH,
      },
    ],
  },
  {
    groupName: NNavigation.EGroupNameInSettings.SYSTEM_SETTINGS,
    groupDataTestId: 'system-settings-title',
    items: [
      {
        name: USERS_LABEL,
        path: USERS_PATH,
        dataTestId: 'users',
      },
      {
        name: INTEGRATIONS_LABEL,
        path: INTEGRATIONS_PATH,
        dataTestId: 'integrations',
      },
      {
        name: PROXY_LABEL,
        path: PROXY_PATH,
        dataTestId: 'proxy',
      },
      {
        name: DATA_MIGRATION_LABEL,
        path: DATA_MIGRATION_PATH,
        dataTestId: 'data-migration',
      },
      {
        name: ACTIONS_HISTORY_LABEL,
        path: ACTIONS_HISTORY_PATH,
        dataTestId: 'history',
      },
      {
        name: MESSAGE_TEMPLATES_LABEL,
        path: MESSAGE_TEMPLATES_PATH,
        dataTestId: MESSAGE_TEMPLATES,
      },
      {
        name: DOCUMENT_TEMPLATES_LABEL,
        path: DOCUMENT_TEMPLATES_PATH,
        dataTestId: DOCUMENT_TEMPLATES,
      },
    ],
  },
  {
    groupName: NNavigation.EGroupNameInSettings.BRANCHES_AND_CHAINS,
    groupDataTestId: 'branches-and-chains-title',
    items: [
      {
        name: BRANCHES_LABEL,
        path: BRANCHES_PATH,
        dataTestId: 'branches',
      },
      {
        name: CHAINS_LABEL,
        path: CHAINS_PATH,
        dataTestId: 'chains',
      },
      {
        name: LEGAL_ENTITIES_LABEL,
        path: LEGAL_ENTITIES_PATH,
        dataTestId: 'legal-entities',
      },
    ],
  },
  {
    groupName: NNavigation.EGroupNameInSettings.FINANCES,
    groupDataTestId: 'finances-title',
    items: [
      {
        name: PAYMENTS_ACCOUNTS_LABEL,
        path: PAYMENTS_ACCOUNTS_PATH,
        dataTestId: 'cashboxes',
      },
      {
        name: SALE_PLANS_LABEL,
        path: SALE_PLANS_PATH,
        dataTestId: 'sales-plans',
      },
      {
        name: OPERATIONS_LABEL,
        path: OPERATIONS_PATH,
        dataTestId: 'financial-operations',
      },
    ],
  },
  {
    groupName: NNavigation.EGroupNameInSettings.AI_OPERATOR,
    groupDataTestId: 'ai-operator-title',
    items: [
      {
        name: AI_PROMPTS_SETTINGS_LABEL,
        path: AI_PROMPTS_SETTINGS_PATH,
        dataTestId: 'ai-prompts-settings',
      },
      {
        name: PAID_AI_FEATURES_LABEL,
        path: PAID_AI_FEATURES_PATH,
        dataTestId: 'paid-ai-features',
      },
      {
        name: ACTIONS_HISTORY_LABEL,
        path: AI_ACTIONS_HISTORY_PATH,
        dataTestId: 'history-of-actions',
      },
      {
        name: MCP_INTEGRATION_LABEL,
        path: MCP_INTEGRATION_PATH,
        dataTestId: 'mcp-connector',
      },
    ],
  },
  {
    groupName: NNavigation.EGroupNameInSettings.PERSONAL_SETTINGS,
    groupDataTestId: 'personal-settings-title',
    items: [
      {
        name: PROFILE_LABEL,
        path: PROFILE_PATH,
        dataTestId: 'personal-account',
      },
    ],
  },
  {
    groupName: NNavigation.EGroupNameInSettings.LEADS_AND_CLIENTS,
    groupDataTestId: 'leads-and-clients-title',
    items: [
      {
        name: SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_LABEL,
        path: SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_PATH,
        dataTestId: 'setting-up-automatic-messaging-to-clients',
      },
      {
        name: DETACH_RESPONSIBLE_FROM_LEAD_LABEL,
        path: DETACH_RESPONSIBLE_FROM_LEAD_PATH,
        dataTestId: 'detach-responsible-from-lead',
      },
      {
        name: CLIENT_FIELDS_LABEL,
        path: CLIENT_FIELDS_PATH,
        dataTestId: 'client-fields',
      },
      {
        name: SUBSCRIPTIONS_LABEL,
        path: SUBSCRIPTIONS_PATH,
        dataTestId: 'subscriptions',
      },
      {
        name: CERTIFICATES_LABEL,
        path: CERTIFICATES_PATH,
        dataTestId: 'certificates',
      },
    ],
  },

  {
    groupName: NNavigation.EGroupNameInSettings.WAREHOUSE,
    groupDataTestId: '',
    items: [
      {
        name: SUPPLIERS_LABEL,
        path: SUPPLIERS_PATH,
        dataTestId: '',
      },
      {
        name: BRANDS_LABEL,
        path: BRANDS_PATH,
        dataTestId: '',
      },
      {
        name: PRODUCT_CATEGORIES_LABEL,
        path: PRODUCT_CATEGORIES_PATH,
        dataTestId: '',
      },
      {
        name: GOODS_UNITS_LABEL,
        path: GOODS_UNITS_PATH,
        dataTestId: '',
      },
      {
        name: PURCHASE_PLANNING_LABEL,
        path: PURCHASE_PLANNING_SETTINGS_PATH,
        dataTestId: '',
      },
    ],
  },
];
